<div class="flex gap-4 items-center">
  <img src="location-secondary.svg" class="w-8 h-8" alt="Location Icon" />
  <p class="text-sm font-medium text-text-700">
    {{ currentAddressText() }}
  </p>
</div>

<app-popover
  #popover
  [title]="'Escolha um endereço'"
  [showCloseIcon]="true"
  [width]="'350px'"
>
  <div trigger>
    <app-icon-button
      label="Alterar"
      [icon]="popover.overlayVisible ? 'expand_less' : 'expand_more'"
      [size]="18"
      (handleClick)="popover.toggle($event)"
    ></app-icon-button>
  </div>

  <div class="flex flex-col gap-3">
    @for (address of addresses(); track address.id) {
      <app-button-card
        [selected]="isSelectedAddress(address.id)"
        (handleClick)="selectAddress(address); popover.hide()"
        (handleKeyEnter)="selectAddress(address); popover.hide()"
      >
        <h4 class="mb-1 text-sm font-medium">{{ address.title }}</h4>
        <p class="text-xs text-text-600">
          {{ getFormattedAddress(address) }}
        </p>
      </app-button-card>
    }
  </div>
</app-popover>
